/**
 * HUB-F — Bandeau accès page réparations legacy.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, ArrowRight } from 'lucide-react';

export default function ActiviteReparationsAccessBanner() {
  return (
    <div
      className="rounded-xl border p-4 space-y-3"
      style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-panel)' }}
      data-testid="activite-reparations-access-banner"
    >
      <div className="flex items-start gap-3">
        <div
          className="shrink-0 w-10 h-10 rounded-xl flex items-center justify-center border"
          style={{ borderColor: 'var(--rm-border-subtle)', background: 'var(--rm-bg-elevated)' }}
        >
          <Wrench className="w-5 h-5 text-[var(--rm-gray-200)]" />
        </div>
        <div>
          <p className="text-sm font-semibold text-[var(--rm-white)]">Gestion réparations complète</p>
          <p className="text-xs text-[var(--rm-gray-500)] mt-0.5">
            Le Centre Activité complète les outils existants — création et suivi inchangés sur /reparations.
          </p>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <Link
          to="/reparations"
          className="btn-secondary px-4 py-2.5 min-h-[44px] text-sm inline-flex items-center gap-2"
          data-testid="activite-reparations-link-legacy"
        >
          Toutes les réparations
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
